const isInstance = (er, ee) => er.constructor === ee

export default isInstance
